import React from "react";
import ValidateForm from "./components/ValidateForm";

function App() {
  return <ValidateForm />;
}

export default App;

